import { Component } from '@angular/core';

@Component({
  selector: 'app-my-bookshelf-detail-page',
  templateUrl: './my-bookshelf-detail-page.component.html',
  styleUrl: './my-bookshelf-detail-page.component.scss',
})
export class MyBookshelfDetailPageComponent {}
